import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type GoogleDriveConnectionStatus =
  | 'idle'
  | 'checking'
  | 'refreshing'
  | 'connected'
  | 'required'
  | 'error'

export interface GoogleDriveState {
  initialized: boolean
  status: GoogleDriveConnectionStatus
  connectedEmail: string | null
}

const initialState: GoogleDriveState = {
  initialized: false,
  status: 'idle',
  connectedEmail: null,
}

const googleDriveSlice = createSlice({
  name: 'googleDrive',
  initialState,
  reducers: {
    setGoogleDriveState: (state, action: PayloadAction<Partial<GoogleDriveState>>) => ({
      ...state,
      ...action.payload,
    }),
    resetGoogleDriveState: () => initialState,
  },
})

export const { setGoogleDriveState, resetGoogleDriveState } = googleDriveSlice.actions
export default googleDriveSlice.reducer
